import { render, staticRenderFns } from "./PayInputConfig.vue?vue&type=template&id=2fea47ad&scoped=true"
import script from "./PayInputConfig.vue?vue&type=script&lang=js"
export * from "./PayInputConfig.vue?vue&type=script&lang=js"
import style0 from "./PayInputConfig.vue?vue&type=style&index=0&id=2fea47ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fea47ad",
  null
  
)

export default component.exports